import FormInput from "../../../controls/FormInput";
import More from "../../../controls/More";
import { truthy } from "../../../util/util";
import { setDownloadModInfo } from "../../download_management/actions/state";
import { setModAttribute } from "../../mod_management/actions/mods";
import { guessFromFileName } from "../util/guessModID";
import * as React from "react";
import { useDispatch } from "react-redux";
import { Button, Icon, IconButton } from "../../../controls/TooltipControls";
function validateNum(value) {
    return !truthy(value) || isNaN(Number(value)) || parseInt(value, 10) < 1
        ? "error"
        : "success";
}
function Input(props) {
    return (React.createElement(FormInput, { groupClass: "no-margin", placeholder: props.placeholder, value: props.value ?? "", validate: props.validate, readOnly: props.onChange === undefined, debounceTimer: 100, onChange: props.onChange }));
}
function saveModId(dispatch, isDownload, gameId, archiveId, modId, newNexusModId) {
    const numId = !newNexusModId ? undefined : parseInt(newNexusModId, 10);
    if (archiveId !== undefined) {
        dispatch(setDownloadModInfo(archiveId, "nexus.ids.modId", numId));
    }
    if (!isDownload) {
        dispatch(setModAttribute(gameId, modId, "modId", numId));
    }
}
function saveFileId(dispatch, isDownload, gameId, archiveId, modId, newNexusFileId) {
    const numId = !newNexusFileId ? undefined : parseInt(newNexusFileId, 10);
    if (archiveId !== undefined) {
        dispatch(setDownloadModInfo(archiveId, "nexus.ids.fileId", numId));
    }
    if (!isDownload) {
        dispatch(setModAttribute(gameId, modId, "fileId", numId));
    }
}
function NexusModIdDetail(props) {
    const { t, activeGameId, archiveId, fileHash, fileName, isDownload, modId, nexusFileId, nexusModId, onCheckForUpdate, onOpenURL, onUpdateByMD5, } = props;
    const [edit, setEdit] = React.useState(false);
    const [modIdTemp, setModId] = React.useState(nexusModId);
    const [fileIdTemp, setFileId] = React.useState(nexusFileId);
    const [fileMD5Temp, setFileMD5] = React.useState(fileHash);
    const dispatch = useDispatch();
    React.useEffect(() => {
        setFileMD5(fileHash);
    }, [fileHash]);
    React.useEffect(() => {
        setModId(nexusModId);
    }, [nexusModId]);
    React.useEffect(() => {
        setFileId(nexusFileId);
    }, [setFileId, nexusFileId]);
    const setFileIdWrap = React.useCallback((fileId) => {
        setFileId(fileId);
    }, [setFileId]);
    const changeEdit = React.useCallback((doEdit = true) => {
        setModId(nexusModId);
        setFileId(nexusFileId);
        setFileMD5(fileHash);
        setEdit(doEdit);
    }, [
        setEdit,
        setModId,
        setFileId,
        setFileMD5,
        nexusModId,
        nexusFileId,
        fileHash,
    ]);
    const startEdit = React.useCallback(() => {
        changeEdit(true);
    }, [changeEdit]);
    const cancel = React.useCallback(() => {
        changeEdit(false);
    }, [changeEdit]);
    const save = React.useCallback(() => {
        saveModId(dispatch, isDownload, activeGameId, archiveId, modId, modIdTemp);
        saveFileId(dispatch, isDownload, activeGameId, archiveId, modId, fileIdTemp);
    }, [
        saveModId,
        saveFileId,
        isDownload,
        activeGameId,
        modId,
        modIdTemp,
        fileIdTemp,
    ]);
    const guessModId = React.useCallback(() => {
        const guessed = guessFromFileName(fileName);
        if (guessed !== undefined) {
            if (isDownload) {
                dispatch(setDownloadModInfo(modId, "nexus.ids.modId", guessed));
            }
            else {
                dispatch(setModAttribute(activeGameId, modId, "modId", guessed));
            }
        }
    }, [dispatch, activeGameId, fileName, modId]);
    const fetchFileId = React.useCallback(() => {
        if (!!fileHash) {
            // have file hash
            onUpdateByMD5();
        }
        else {
            onCheckForUpdate();
        }
    }, [onUpdateByMD5, onCheckForUpdate, fileHash, modId]);
    const validNum = React.useCallback((value) => {
        return validateNum(value);
    }, []);
    if (edit) {
        const haveHash = !!fileHash;
        const hashValidation = !!fileMD5Temp
            ? "success"
            : !!fileIdTemp
                ? null
                : "error";
        const changeMade = (nexusModId ?? "") !== (modIdTemp ?? "") ||
            (nexusFileId ?? "") !== (fileIdTemp ?? "");
        return (React.createElement("div", { className: "modid-detail" },
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            t("File Hash"),
                            React.createElement(More, { id: "file-hash", name: t("File Hash (MD5)") }, t("A hash can be calculated from any mod archive on disk and we can " +
                                "use it to look up all other information Nexus Mods has on a mod. " +
                                "If the archive has been deleted before we saved the hash there is no " +
                                "way to get at it."))),
                        React.createElement("td", null,
                            React.createElement(Input, { value: fileMD5Temp, validate: hashValidation, placeholder: t("e.g. {{sample}}", {
                                    replace: { sample: "14758f1afd44c09b7992073ccf00b43d" },
                                }) })),
                        React.createElement("td", { className: "modid-detail-control" }, archiveId !== undefined && !haveHash ? (React.createElement(Button, { disabled: !fileIdTemp, onClick: onUpdateByMD5, tooltip: t("Calculate hash (can take a moment)") }, t("Fetch"))) : null)),
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            t("Mod ID"),
                            React.createElement(More, { id: "nexus-mod-id", name: t("Mod ID") }, t("The mod id identifies a mod page on nexus mods. It helps us find " +
                                "the name, description, author, ... of a mod but with this id alone, " +
                                "we don't know which file exactly (version, variant) this is."))),
                        React.createElement("td", null,
                            React.createElement(Input, { value: modIdTemp ?? "", onChange: setModId, validate: validNum, placeholder: t("e.g. {{sample}}", {
                                    replace: { sample: "1337" },
                                }) })),
                        React.createElement("td", { className: "modid-detail-control" }, haveHash ? (React.createElement(Button, { onClick: onUpdateByMD5, tooltip: t("Look up by file hash") }, t("Query Server"))) : (React.createElement(Button, { onClick: guessModId, tooltip: t("Guess the mod id based on the file name") }, t("Guess"))))),
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            t("File ID"),
                            React.createElement(More, { id: "nexus-file", name: t("File ID") }, t("The file id identifies a specific file. We need this to check for " +
                                "updates, to include mods in a collection and to correctly identify " +
                                "if you try to install a second copy of the same file for example."))),
                        React.createElement("td", null,
                            React.createElement(Input, { value: fileIdTemp ?? "", onChange: setFileIdWrap, validate: validNum, placeholder: t("e.g. {{sample}}", {
                                    replace: { sample: "1337" },
                                }) })),
                        React.createElement("td", { className: "modid-detail-control" },
                            React.createElement(Button, { onClick: fetchFileId, tooltip: haveHash
                                    ? t("Look up")
                                    : t("Look up. May fail if the mod has been hidden/archived by the author.") }, t("Query Server")))))),
            React.createElement(Button, { onClick: cancel, tooltip: t("Close") }, t("Close")),
            " ",
            React.createElement(Button, { disabled: !changeMade, onClick: save, tooltip: t("Save changes") }, t("Apply"))));
    }
    else {
        const valid = !nexusModId
            ? t("No mod id")
            : !nexusFileId
                ? t("No file id")
                : true;
        return (React.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            } },
            React.createElement(Icon, { className: valid === true ? "nexus-id-valid" : "nexus-id-invalid", name: valid === true ? "feedback-success" : "feedback-warning", tooltip: valid === true
                    ? t("Mod identified")
                    : t("Mod not identified correctly") }),
            React.createElement("div", null, valid === true ? `M: ${nexusModId}, F: ${nexusFileId}` : valid),
            React.createElement(IconButton, { icon: "edit", tooltip: t("Edit"), onClick: startEdit, className: "btn-embed" }),
            nexusModId !== undefined ? (React.createElement(IconButton, { icon: "open-in-browser", tooltip: t("Open on Nexus Mods"), onClick: onOpenURL, className: "btn-embed" })) : null));
    }
}
export default NexusModIdDetail;
